module.exports = __webpack_public_path__ + "img/children-boots.f84bf134.webp";